import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useQuery } from "@tanstack/react-query";
import { MaintenanceObjectiveSystemData } from "../types/MaintenanceObjectiveSystem.type";

const useMaintenanceObjectiveSystem = (id?: string) => {
  const privateAxios = usePrivateAxios();

  return useQuery<{ data: { data: MaintenanceObjectiveSystemData } }, unknown, MaintenanceObjectiveSystemData>({
    enabled: !!id,
    queryKey: ['maintenanceObjectiveSystem', id],
    queryFn: () => privateAxios.get(`/maintenance/objective_systems/${id}`),
    select: (data) => data?.data?.data,
  });
}

export default useMaintenanceObjectiveSystem;
